import { useState } from "react";
import { CheckCircle, ChevronDown } from "lucide-react";

export default function EaseExplainer({ offer }) {
  const [open, setOpen] = useState(false);
  const criteria = [];
  const noApp = !offer.offer_requires_app;
  const noPurchase = !offer.offer_purchase_required;
  const noSignup = !((offer.offer_signup_lead_days || 0) > 0);
  const noMinSpend = !((offer.min_spend || 0) > 0);
  const w = offer.offer_window_days || 7;
  const generous = w >= 30;
  const tight = w <= 1;
  const narrow = w > 1 && w <= 6;

  criteria.push({ label: "No app needed", earned: noApp, pts: 1, color: noApp ? "text-emerald-600" : "text-slate-400" });
  criteria.push({ label: "No purchase required", earned: noPurchase, pts: 1.5, color: noPurchase ? "text-emerald-600" : "text-slate-400" });
  criteria.push({ label: "No advance signup", earned: noSignup, pts: 1, color: noSignup ? "text-emerald-600" : "text-slate-400" });
  criteria.push({ label: "No minimum spend", earned: noMinSpend, pts: 0.5, color: noMinSpend ? "text-emerald-600" : "text-slate-400" });
  if (generous) criteria.push({ label: `Generous window (${w} days)`, earned: true, pts: 1, color: "text-emerald-600" });
  else if (tight) criteria.push({ label: "Birthday-only (1 day)", earned: false, pts: 1, color: "text-slate-400" });
  else if (narrow) criteria.push({ label: `Short window (${w} days)`, earned: false, pts: 0.5, color: "text-slate-400" });

  const actualScore = Math.min(5, criteria.filter(c => c.earned).reduce((sum, c) => sum + c.pts, 0));
  const displayScore = actualScore;

  if (criteria.length <= 1) return null;
  return (
    <div className="mt-2">
      <button onClick={() => setOpen(!open)} className="text-xs text-sky-500 font-medium flex items-center gap-1" data-testid="ease-explainer-toggle">
        Why {displayScore % 1 === 0 ? displayScore : displayScore.toFixed(1)}/5?
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-2 bg-slate-50 rounded-xl p-3 space-y-1.5" data-testid="ease-explainer-content">
          {criteria.map((c, i) => (
            <div key={i} className="flex items-center justify-between text-xs">
              <span className={`flex items-center gap-1.5 ${c.earned ? "text-slate-700" : "text-slate-400"}`}>
                {c.earned ? <CheckCircle className="w-3 h-3 text-emerald-500" /> : <span className="w-3 h-3 rounded-full border border-slate-300 inline-block" />}
                {c.label}
              </span>
              <span className={`font-semibold ${c.color}`}>{c.earned ? `+${c.pts}` : "—"}</span>
            </div>
          ))}
          <div className="flex items-center justify-between text-xs pt-1.5 border-t border-slate-200 mt-1">
            <span className="font-semibold text-slate-700">Score</span>
            <span className="font-bold text-sky-600">{displayScore % 1 === 0 ? displayScore : displayScore.toFixed(1)}/5</span>
          </div>
        </div>
      )}
    </div>
  );
}
